<template>
  <div id="hero">
    <HeroContainer/>
  </div>
</template>

<script>
import HeroContainer from '@/components/HeroContainer.vue'

export default {
  name: 'Hero',
  components: {
    HeroContainer
  }
}
</script>

<style scoped lang="scss">
#hero {
  height: 100vh;
  top: 0;
  left: 0;
  width: 100%;
  height: --webkit-fill-available;
  background: url("../assets/hero-background.jpg") no-repeat center center;
  background-size: cover;
  z-index: -1;
}

#hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  height: --webkit-fill-available;
  background: rgba(4, 5, 7, 0.5);
}
</style>
